import { Component, OnInit, Input, Output, OnChanges, SimpleChanges, EventEmitter, AfterViewInit } from '@angular/core';
import { CommonService } from 'src/app/modules/service/common/common.service';

declare let BMap: any;
let map;
let point;

@Component({
  selector: 'map-preview',
  templateUrl: './map-preview.component.html',
  styleUrls: ['./map-preview.component.less'],
})
export class MapPreviewComponent implements OnInit, AfterViewInit {
  @Input() show: boolean = false;
  @Input() style: object = {
    width: '1000px',
    height: '470px',
  };
  @Input() search: string = '';
  @Input() result: any = '';
  @Input() location = { longitude: '', latitude: '' };
  @Output() locationChange = new EventEmitter();

  constructor(private common: CommonService) {
  }

  ngOnInit(): void {
    const result = this.result.split(',');
    if (result[0] == '') {
      result[0] = '116.404';
      result[1] = '39.915';
      this.result = '';
    }
    const new_point = new BMap.Point(result[0], result[1]);

    setTimeout(() => {
      map = new BMap.Map('map'); // 创建地图实例
      point = new BMap.Point(new_point); // 创建点坐标
      map.centerAndZoom(point, 15); // 初始化地图，设置中心点坐标和地图级别
      map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
    }, 500);
    setTimeout(() => {

      map.clearOverlays();
      const marker = new BMap.Marker(new_point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      map.panTo(new_point);
    }, 1500);
  }

  ngAfterViewInit(): void {
  }

  /**
   * 外部传参事件
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['result'] != undefined && this.result != undefined) {
      const result = this.result.split(',');
      this.location = { longitude: result[0], latitude: result[1] };
    }
  }

  /**
   * 回到定位点
   */
  backPoint(): void {
    const result = this.result.split(',');
    if (result[0] == '') {
      result[0] = '116.404';
      result[1] = '39.915';
      this.result = '';
    }
    const new_point = new BMap.Point(result[0], result[1]);
    map.setCenter(new_point);
  }
}
